"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var languageSlice_1 = require("../../../features/languages/languageSlice");
var localization_1 = require("../../../helpers/localization");
var Localization_1 = require("../../../constants/Localization");
var useSelectSearchPageAddress_1 = require("../../../hooks/useSelectSearchPageAddress");
var useLocationPathName_1 = require("../../../hooks/useLocationPathName");
var searchParamsSlice_1 = require("../../../features/searchParams/searchParamsSlice");
var react_router_dom_1 = require("react-router-dom");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var LanguageList = function () {
    var location = react_router_dom_1.useLocation();
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var address = useSelectSearchPageAddress_1.useSelectSearchPageAddress(location, false);
    var locationPathName = useLocationPathName_1.useLocationPathName(location);
    var deal = react_1.useMemo(function () { return Localization_1.PagePrefix[locationPathName]; }, [locationPathName]);
    var seoCleanLocationSubDirectoryPrefix = react_redux_1.useSelector(searchParamsSlice_1.useSelectSeoCleanLocationSubDirectoryPrefix);
    var onChange = function (language) {
        if (!seoCleanLocationSubDirectoryPrefix) {
            localization_1.handleChangeLocalization(language);
        }
        else {
            localization_1.handleChangeSEOCleanURLLocalization(seoCleanLocationSubDirectoryPrefix, currentLanguage, language, deal, locationPathName, address);
        }
    };
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.cm_dropdown },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.lang_item, onClick: function () { return onChange(Localization_1.Language.hy); } },
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", { className: "flag flag-am" }),
                react_1.default.createElement("span", { className: styles_module_scss_1.default.lang_name }, "\u0540\u0561\u0575")),
            react_1.default.createElement("i", { className: classnames_1.default('check icon', currentLanguage === Localization_1.Language.hy
                    ? styles_module_scss_1.default.active
                    : styles_module_scss_1.default.lang_icon) })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.lang_item, onClick: function () { return onChange(Localization_1.Language.ru); } },
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", { className: "flag flag-ru" }),
                react_1.default.createElement("span", { className: styles_module_scss_1.default.lang_name }, "\u0420\u0443\u0441")),
            react_1.default.createElement("i", { className: classnames_1.default('check icon', currentLanguage === Localization_1.Language.ru
                    ? styles_module_scss_1.default.active
                    : styles_module_scss_1.default.lang_icon) }))));
};
exports.default = react_1.memo(LanguageList);
